import * as React from "react";
import type { SVGProps } from "react";

interface TwoPointConversionProps extends SVGProps<SVGSVGElement> {
  cancelled?: boolean;
}
const TwoPointConversion = ({ cancelled = false, ...props }: TwoPointConversionProps) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
    <g>
    <g fill="none" fillRule="evenodd">
      <path
        fill="#FFF"
        fillRule="nonzero"
        d="M4.86 3.84C.49 7.4-1.2 12.88 1.45 16.18c2.65 3.31 8.31 2.78 12.68-.8s6.05-9.04 3.41-12.34C14.9-.28 9.23.26 4.86 3.84m.88 1.07c3.84-3.15 8.64-3.6 10.72-1 2.08 2.59.64 7.25-3.2 10.4-3.85 3.15-8.65 3.6-10.73 1-2.08-2.59-.64-7.25 3.2-10.4Z"
      />
      <path
        fill="#FFF"
        fillRule="nonzero"
        d="M5.74 4.91c3.84-3.15 8.64-3.6 10.72-1 2.08 2.59.64 7.25-3.2 10.4-3.85 3.15-8.65 3.6-10.73 1-2.08-2.59-.64-7.25 3.2-10.4Z"
      />
      <path
        fill="#000"
        d="M1.95 9.09a37 37 0 0 0 2.78 4.3c.71.89 1.9 2.1 3.54 3.61l-2.74.69-4.34-5.83zM17 10.1a37 37 0 0 0-2.78-4.3c-.71-.9-1.9-2.1-3.54-3.62l2.74-.69 4.34 5.83z"
      />
      <path
        fill="#000"
        fillRule="nonzero"
        d="M12.13 4.75c.17.23.12.55-.1.72l-.59.43-.31.23.37.43a.4.4 0 0 1-.6.52l-.4-.47-.67.5.4.44a.4.4 0 0 1-.6.52L9.2 7.6l-.67.53.4.46a.4.4 0 0 1-.6.52l-.4-.48-.29.24-.13.12-.18.16.4.43a.4.4 0 1 1-.58.54l-.4-.43-.66.62.42.44a.4.4 0 0 1-.57.55l-.42-.44-.81.83a.51.51 0 1 1-.74-.72l.84-.85-.42-.43a.4.4 0 0 1 .57-.55l.41.43.67-.63-.42-.45a.4.4 0 0 1 .58-.54l.43.45.2-.18.3-.26.12-.1-.38-.44a.4.4 0 0 1 .6-.52l.39.45.66-.53-.37-.43a.4.4 0 0 1 .6-.52l.4.47.66-.5-.38-.44a.4.4 0 1 1 .6-.52l.41.48.96-.71a.51.51 0 0 1 .72.11Z"
      />
      <path
        fill="#000"
        fillRule="nonzero"
        d="M5.23 4.3C9.38.9 14.67.4 17.08 3.4c2.4 3 .82 8.13-3.32 11.52-4.15 3.4-9.44 3.9-11.85.89-2.4-3-.82-8.12 3.32-11.51m11.23-.4C14.38 1.3 9.58 1.76 5.74 4.91c-3.85 3.15-5.29 7.81-3.2 10.4 2.07 2.6 6.87 2.15 10.72-1 3.84-3.15 5.28-7.81 3.2-10.4Z"
      />
      <path
        fill="#FFF"
        fillRule="nonzero"
        d="M16 8.75a7.75 7.75 0 1 0 0 15.5 7.75 7.75 0 0 0 0-15.5"
      />
      <path
        fill="#007BBD"
        fillRule="nonzero"
        d="M16 9.5a7 7 0 1 1 0 14 7 7 0 0 1 0-14"
      />
      <path
        fill="#FFF"
        fillRule="nonzero"
        d="M12.83 14.83c.26 0 .47.23.47.5v1.53h1.53c.28 0 .5.21.5.47s-.22.47-.5.47H13.3v1.53c0 .28-.2.5-.47.5-.26 0-.47-.22-.47-.5V17.8h-1.53c-.27 0-.5-.2-.5-.47 0-.26.23-.47.5-.47h1.53v-1.53c0-.27.21-.5.47-.5m3.77 5.67c-.54 0-.8-.14-.8-.43a3.52 3.52 0 0 1 .79-2.25c.28-.39.67-.82 1.15-1.28.24-.23.47-.46.69-.7.21-.23.39-.46.53-.69.13-.22.2-.44.21-.64q.015-.555-.24-.84-.27-.27-.75-.27c-.41 0-.68.2-.82.58-.08.24-.18.43-.29.56-.11.12-.28.19-.51.19a.66.66 0 0 1-.53-.22c-.13-.15-.17-.36-.11-.62.14-.6.4-1.05.8-1.38.4-.32.89-.48 1.46-.48.46 0 .88.1 1.25.3.37.19.66.47.88.84.2.38.3.83.29 1.38 0 .38-.1.73-.26 1.04s-.38.62-.66.92c-.27.3-.6.62-.95.97-.35.34-.65.66-.92.97-.27.3-.43.55-.47.74h2.3c.53 0 .8.22.8.65 0 .44-.27.66-.8.66h-3.05Z"
      />
    </g>
        {cancelled && (
        <rect
          width="25"
          height="2.5"
          x="-.494"
          y="10.746"
          fill="#000"
          fillRule="evenodd"
          stroke="#FFF"
          rx="1"
          transform="rotate(-45 12.006 11.996)"
        />
      )}
    </g>
  </svg>
);
export default TwoPointConversion;
